import React, {useEffect, useState} from "react";
import animateCss from "../../utils";
import "./index.scss";

class Loading extends React.Component {
    state = {
        loaded: false
    }
    ref = React.createRef()
    line = React.createRef()
    componentDidMount() {
        setTimeout(()=>{
            animateCss(this.line.current, "slideInLeft")
            .then(()=>{
                document.getElementsByClassName("loading-content")[0].style.border = "none"
                animateCss(this.line.current, "slideOutRight")
                .then(()=>{
                    animateCss(this.ref.current, "fadeOut")
                })
                .then(res=>{
                    setTimeout(()=>{ 
                        this.setState({ loaded: true })
                    }, 2000)
                    this.props.onLoaded()
                })
            })
        }, 1500)
    }
    render() {
        return <div>
            {
                this.state.loaded 
                ? 
                null
                :
                <div className="loading-wrap" ref={this.ref}>
                    <div className="loading-content">
                        <div className="loading-text">Loading</div>
                        <div className="loading-line" ref={this.line}></div>
                    </div>
                </div>
            }
        </div>
    }
}

export default Loading;